module.exports = __webpack_public_path__ + "static/media/signOut.7faf71a2.svg";